(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/game/assets/javascripts/views/size-picker.js') >= 0) return;  svs.modules.push('/components/numbergames/game/assets/javascripts/views/size-picker.js');

'use strict';

svs.numbergames.game.views.SizePicker = Marionette.View.extend({
  possibleSizes: {},
  invertButtons: false,
  ui: {
    sizeRadio: '.js-size-radio'
  },
  triggers: {
    'change @ui.sizeRadio': 'changeSize'
  },
  className() {
    const brandingSuffix = svs.numbergames.productMapping.getBrandingClass(this.model.get('productId'));
    return "numbergames-size-picker numbergames-size-picker-".concat(brandingSuffix);
  },
  template(data) {
    return svs.numbergames.game.templates.size_picker(data);
  },
  templateContext() {
    const rules = svs.numbergames.game_model.rulesRadio.request('rules');
    const packageRules = rules.PACKAGES;
    if (!packageRules) return;
    return {
      possibleSizes: Object.keys(packageRules),
      size: this.options.size,
      invertButtons: this.getOption('invertButtons'),
      transparentButton: !svs.numbergames.productMapping.isEurojackpot(this.model.get('productId'))
    };
  },
  onChangeSize(view, event) {
    var _svs$numbergames$game, _svs$numbergames$game2;
    const size = event.target.value;
    svs.core.data.title = {
      packageSize: size
    };
    svs.core.data.metaDescription = {
      packageSize: size
    };
    const router = (_svs$numbergames$game = (_svs$numbergames$game2 = svs.numbergames.game_app) === null || _svs$numbergames$game2 === void 0 ? void 0 : _svs$numbergames$game2.router) !== null && _svs$numbergames$game !== void 0 ? _svs$numbergames$game : Backbone.history;
    router.navigate("fardiga-spel/".concat(size), {
      replace: true
    });
    this.model.setPackage(size);
  }
});

 })(window);